import {base, baseConfig} from "../Services/api";

export function create(obj) {
    const conf = {
        method: 'POST',
        body: JSON.stringify(obj),
        ...baseConfig
    };

    return fetch(`${base}questions`, conf);
}

export function get(venueId) {
    let url = `${base}questions?limit=500`;
    if (venueId) {
        url += `&venueId=${venueId}`;
    }
    return fetch(url, baseConfig);
}

export function getOne(id) {
    return fetch(`${base}questions/${id}`, baseConfig);
}

export function deleteOne(id) {
  const conf = {
    method: 'DELETE',
    ...baseConfig
  };
  return fetch(`${base}questions/${id}`, conf);
}

export function update(id, obj) {
    const conf = {
        method: 'PUT',
        body: JSON.stringify(obj),
        ...baseConfig
    };
    return fetch(`${base}questions/${id}`,conf);
}
